import { createSlice } from "@reduxjs/toolkit";

export const basketSlice = createSlice({
  name: "basket",
  initialState: {
    userId: null,
    basket: [],
  },
  reducers: {
    addUserIdToBasket: (state, action) => {
      state.userId = action.payload.userId;
    },
    clearBasket: (state) => {
      state.basket = [];
    },
    addItemToBasket: (state, action) => {
      const newBasket = action.payload;
      let exists = false;
      const existingBaskets = JSON.parse(JSON.stringify(state.basket));
      existingBaskets.some((e) => {
        if (e.id === newBasket.id) {
          e.quantity++;
          e.price = (parseFloat(e.price) + parseFloat(newBasket.price)).toFixed(
            2
          );
          console.log(e.price);
          exists = true;
        }
      });
      if (exists) {
        const newBaskets = [...existingBaskets];
        state.basket = newBaskets;
      } else {
        const newBaskets = [...existingBaskets, newBasket];
        state.basket = newBaskets;
      }
    },
    decreaseQuantity: (state, action) => {
      const newBasket = action.payload;
      const existingBaskets = JSON.parse(JSON.stringify(state.basket));
      existingBaskets.some((e) => {
        if (e.id === newBasket.id) {
          e.quantity--;
          e.price = (
            parseFloat(e.price) - parseFloat(newBasket.originalPrice)
          ).toFixed(2);
        }
      });
      const newBaskets = [...existingBaskets];
      state.basket = newBaskets;
      console.log(newBaskets);
    },
    remoteItemFromBasket: (state, action) => {
      console.log(action.payload);
      const index = state.basket.findIndex(
        (basketItem) => basketItem.id === action.payload.id
      );
      let newBasket = [...state.basket];
      if (index >= 0) {
        newBasket.splice(index, 1);
      } else {
        console.warn("Cant remove product as its not in basket!");
      }
      state.basket = newBasket;
    },
  },
});

export const {
  addItemToBasket,
  remoteItemFromBasket,
  addUserIdToBasket,
  clearBasket,
  decreaseQuantity,
} = basketSlice.actions;

export const selectBasket = (state) => state.basket.basket;
export const selectBasketUserId = (state) => state.basket.userId;

export default basketSlice.reducer;
